/**
 * Admin navigation items.
 * Used when the current page is an admin page (URL starts with /admin).
 *
 * Frequently used surfaces (Organizations, Moments, Settings) stay top-level;
 * the rest is grouped into dropdowns by domain. A dropdown auto-hides when
 * every sub-item is filtered out by `show` (see AppNavbar).
 *
 * Show predicates use trueUser* (not user.*) so that during impersonation
 * the admin keeps seeing their nav — current_user is the impersonated user
 * (no system role) but true_user is the actual admin operator.
 *
 * - trueUserAppAdmin (root + admin) — broad /admin/* surface
 * - trueUserContentTeam (root + admin + content_manager) — Moments
 * - trueUserSystem (any system role, incl. documentation_manager) — Docs
 */
export default [
  {
    label: 'Organizations',
    href: '/admin/organizations',
    urlPrefix: '/admin/organizations',
    show: (store) => store.trueUserAppAdmin
  },
  {
    label: 'Moments',
    href: '/admin/moments',
    urlPrefix: '/admin/moments',
    show: (store) => store.trueUserContentTeam
  },
  {
    label: 'Customers',
    items: [
      {
        label: 'Cancellations',
        href: '/admin/cancelations',
        urlPrefix: '/admin/cancelations',
        show: (store) => store.trueUserAppAdmin
      },
      {
        label: 'Mailer Log',
        href: '/admin/mailer-log',
        urlPrefix: '/admin/mailer-log',
        show: (store) => store.trueUserAppAdmin
      },
      {
        label: 'Hubspot',
        href: '/admin/hubspot',
        urlPrefix: '/admin/hubspot',
        show: (store) => store.trueUserAppAdmin && store.wlc.appCodename === 'lo'
      }
    ]
  },
  {
    label: 'MLAP',
    items: [
      {
        label: 'Playbooks',
        href: '/admin/mlap_playbooks',
        urlPrefix: '/admin/mlap_playbooks',
        show: (store) => store.trueUserAppAdmin
      },
      {
        label: 'Onboarding',
        href: '/admin/mlap_onboardings',
        urlPrefix: '/admin/mlap_onboardings',
        show: (store) => store.trueUserAppAdmin
      },
      {
        label: 'ServiceTitan',
        href: '/admin/service_titan/tenants',
        urlPrefix: '/admin/service_titan',
        show: (store) => store.trueUserAppAdmin
      }
    ]
  },
  {
    label: 'Tools',
    items: [
      {
        label: 'Data Migration',
        href: '/admin/data_migration_runs',
        urlPrefix: '/admin/data_migration_runs',
        show: (store) => store.trueUserAppAdmin && store.wlc.appCodename === 'lv'
      },
      {
        label: 'GeoCompare',
        href: '/admin/compare_providers/scan_sessions',
        urlPrefix: '/admin/compare_providers',
        show: (store) => store.trueUserAppAdmin
      },
      {
        label: 'LSA Multi-Account',
        href: '/admin/lsa/team_accounts',
        urlPrefix: '/admin/lsa',
        show: (store) => store.trueUserAppAdmin
      },
      {
        label: 'Changelog',
        href: '/admin/changelog_entries',
        urlPrefix: '/admin/changelog_entries',
        show: (store) => store.trueUserAppAdmin
      },
      {
        label: 'Docs',
        href: '/admin/documentation',
        urlPrefix: '/admin/documentation',
        show: (store) => store.trueUserSystem && store.wlc.appCodename === 'lo'
      }
    ]
  },
  {
    label: 'Settings',
    href: '/admin/settings/onboarding_flows',
    urlPrefix: '/admin/settings',
    show: (store) => store.trueUserAppAdmin
  }
]
